import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import close from '../Asset/close.svg';
import { ButtonGroup, Modal } from 'react-bootstrap';
import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from "recharts";
import { Form, Button } from "react-bootstrap";
import { useTable, useGlobalFilter, useAsyncDebounce, usePagination, useSortBy } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faArrowDownShortWide, faArrowUpWideShort, faBars } from '@fortawesome/free-solid-svg-icons';
import { getUserInfo, getDashboard } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Incident() {
  const dashboard = sessionStorage.getItem('Dashboards') ? getDashboard() : [];
  let monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let userObj = getUserInfo();
  let tdate = new Date();
  var dd = String(tdate.getDate()).padStart(2, '0');
  var mm = String(tdate.getMonth() + 1).padStart(2, '0');
  var yyyy = tdate.getFullYear();
  let [sessOut, setSessOut] = useState(false);
  let [siteList, setSiteList] = useState([]);
  let [allAseet, setAllAsset] = useState([]);
  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });
  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);
  let [incident, setIncident] = useState([]);
  let [lastIncident, setLastIncident] = useState([]);
  let [years, setYears] = useState([]);
  let [filterDefault, setFilterDefault] = useState({
    801: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      month: yyyy + "-" + mm,
      // year: "",
      // fromDate: yyyy + "-" + mm + "-" + dd,
      // toDate: yyyy + "-" + mm + "-" + dd,
    },
    802: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    }
  })


  let [filterHis, setFilterHis] = useState({
    801: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      month: yyyy + "-" + mm
    },
    802: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    }
  })

  useEffect(() => {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let abortController = new AbortController();
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();

    let tempy = [];
    for (let i = 0; i < 3; i++) {
      tempy.push(yyyy - i);
    }
    setYears(tempy);

    if (globObj && globObj != 'undefined') {
      setFilter(globObj);
      saveGlobelFilter('store', globObj);
    }
    else {
      if (dashboard.indexOf(801) >= 0) {
        getIncidentCount(filterHis[801]);
      }
      if (dashboard.indexOf(802) >= 0) {
        getLatestIncident(filterHis[802]);
      }
    }

    getProductCategory();
    getDropDown();
    getSiteList();

    return () => {
      abortController.abort();
    }
  }, []);

  function saveGlobelFilter(type, obj) {
    let val = {}, filObj;
    if (type == "store") {
      val = obj;
    }
    else {
      sessionStorage.setItem("GloberFilter", JSON.stringify({
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      }));
      val = {
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      };
    }
    filObj = {
      "801": {
        equipmentID: val.equipmentID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        month: val.month != "" ? val.month : yyyy + "-" + mm,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID
      },
      "802": val
    }
    setFilterHis(filObj);
    allApiCall(filObj);
  }
  function allApiCall(req) {
    if (dashboard.indexOf(801) >= 0) {
      getIncidentCount(req[801]);
    }
    if (dashboard.indexOf(802) >= 0) {
      getLatestIncident(req[802]);
    }
  }
  function clearFilter(dashID) {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    setAllAsset([]);

    if (globObj && globObj != 'undefined') {
      sessionStorage.removeItem('GloberFilter');
      getIncidentCount(filterDefault[801]);
      getLatestIncident(filterDefault[801]);
      setFilterHis({
        801: filterDefault[801],
        802: filterDefault[802]
      });
    }
    else {
      setFilterHis({ ...filterHis, [dashID]: filterDefault[dashID] });
      if (dashID == 801) {
        getIncidentCount(filterDefault[801]);
      }
      if (dashID == 802) {
        getLatestIncident(filterDefault[802]);
      }
    }

    handleClose();

  }

  let [pwidth, setPwidth] = useState(null);
  const parentRef = useRef(null);
  useEffect(() => {
    if (parentRef.current) {
      setPwidth(parentRef.current.offsetWidth)
    }
  }, [parentRef]);

  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setCate(resp.data.result.categories);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setCate([]);
        }
      })
    })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }

  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {

      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setDropDownData({
            asset_equipmentType: [
              { name: "" },
            ]
          })
        }
      })
    })
  }
  function getSiteList() {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setSiteList(resp.data.result.siteList);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setSiteList([]);
        }
      })
    })
  }
  function getAssetList() {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  function getEquipmentBySite(sid) {
    fetch(environment.baseUrl + "getEquipmentBySite?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          siteID: sid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setSubCate([]);
    setFilter({
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      fromDate: "",
      toDate: "",
      month: "",
      year: "",
      productCategoryID: "",
      productSubCategoryID: "",
    });
  };
  const handleShow = (dashID) => {
    setFilter(filterHis[dashID]);
    setFilterDash(dashID);
    if (filterHis[dashID].siteID == "") {
      getAssetList();
    }
    else {
      getEquipmentBySite(filterHis[dashID].siteID);
    }
    if (filterHis[dashID].productCategoryID != "") {
      getProductSubCategory(filterHis[dashID].productCategoryID)
    }
    setShow(true);
  }
  let [filterDash, setFilterDash] = useState(null);
  let [filter, setFilter] = useState({
    equipmentID: "",
    equipmentType: "",
    siteID: "",
    fromDate: "",
    toDate: "",
    month: "",
    year: "",
    productCategoryID: "",
    productSubCategoryID: ""
  });

  function getFilterData(e) {
    if (e.target.name === "productCategoryID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      getProductSubCategory(parseInt(e.target.value));
    }
    else if (e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      if (e.target.name === "siteID") {
        getEquipmentBySite(e.target.value);
      }
    }
    else if (e.target.name == "fromDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "toDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "month") {
      setFilter({ ...filter, [e.target.name]: e.target.value, year: "", fromDate: "", toDate: "" });
    }
    else if (e.target.name == "year") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", fromDate: "", toDate: "" });
    }
    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  }
  function getFilterFields() {
    setFilterHis({ ...filterHis, [filterDash]: filter })
    if (filterDash == 801) {
      getIncidentCount(filter);
    }
    else {
      getLatestIncident(filter);
    }
  }

  function getIncidentCount(obj) {
    fetch(environment.baseUrl + "dayWiseIncidentCounts", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          month: obj.month,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        }
      )

    }).then((result) => {
      result.json().then((res) => {
        let lables = res.data.labels;
        let temp = [];
        if (res.code == 200) {

          res.data.incidentCountDetails.forEach(element => {
            let obj = {};
            element.forEach((item, i) => {
              obj[lables[i]] = item;
            });
            temp.push(obj);
          });
          setIncident(temp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setIncident([])
        }
        handleClose();
      })
    })
  }


  function getLatestIncident(obj) {
    fetch(environment.baseUrl + "equipmentWiseLatestIncident", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        equipmentID: obj.equipmentID,
        equipmentType: obj.equipmentType,
        siteID: obj.siteID,
        productCategoryID: obj.productCategoryID,
        productSubCategoryID: obj.productSubCategoryID,
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          let temp = [];
          res.data.latestIncident.map((item) =>
            temp.push({
              assetID: item[0],
              engineColTemp: item[1],
              traOilTrmp: item[2],
              batteryCharge: item[3],
              airCleaner: item[4],
              ops: item[5],
              fuelWarnning: item[6],
              oilPressure: item[7],
            })
          )
          setLastIncident(temp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setLastIncident([]);
        }
        handleClose();
      })
    })
  }

  ///////////////////////////////Last Incident Details///////////////
  const columns = useMemo(
    () => [
      {
        Header: 'Equipment ID ',
        accessor: 'assetID',
      },
      {
        Header: "Engine High Coolant Temp.",
        accessor: 'engineColTemp',

      },
      {
        Header: "High Transmission Oil Temp.",
        accessor: 'traOilTrmp',

      },
      {
        Header: "Battery Charging",
        accessor: 'batteryCharge',

      },
      {
        Header: "Clogged Air Cleaner",
        accessor: 'airCleaner',

      },
      {
        Header: "OPS",
        accessor: 'ops',

      },
      {
        Header: "Low Fuel Level Warning",
        accessor: 'fuelWarnning',

      },
      {
        Header: "Engine Oil Pressure",
        accessor: 'oilPressure',

      },
    ],
    []
  )
  function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter, }) {
    const count = preGlobalFilteredRows.length
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
      setGlobalFilter(value || undefined)
    }, 200)
    return (
      <Form.Group>
        <Form.Control type="text"
          style={{ width: '170px' }}
          value={value || ""}
          onChange={e => {
            setValue(e.target.value);
            onChange(e.target.value);
          }} className="textbox-back"
          placeholder={`Search`}
        />
      </Form.Group>
    )
  }
  function Table({ columns, data }) {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      //rows,//use when we not use pagination
      page,//use when we use pagination
      prepareRow,
      //for globle filter
      state,
      preGlobalFilteredRows,
      setGlobalFilter,
      //for pagination
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: { pageIndex, pageSize },
    } = useTable({ columns, data, }, useGlobalFilter, useSortBy, usePagination)

    return (
      <>
        <div className="row">
          <div className="col-sm-4 left-col">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          </div>

        </div>
        <div className="table-responsive mt-3">
          <table {...getTableProps()} className="table">
            <thead className='table-secondary'>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      {column.render('Header')}
                      &nbsp; <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? <FontAwesomeIcon icon={faArrowDownShortWide} />
                            : <FontAwesomeIcon icon={faArrowUpWideShort} />
                          : <FontAwesomeIcon icon={faSort} />}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      if (cell.column.id != "assetID") {
                        return (
                          <td
                            {...cell.getCellProps()}
                            style={{ textAlign: 'center' }}
                          >
                            {cell.render('Cell')}
                          </td>
                        )
                      }
                      else {
                        return (
                          <td
                            {...cell.getCellProps()}
                          >
                            {cell.render('Cell')}
                          </td>
                        )
                      }
                    }

                    )}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className="row mt-2">
          <div className="col-sm-5 left-col">
            <ButtonGroup variant="outlined" aria-label="outlined button group">
              <Button className="pagi-btn" onClick={() => gotoPage(0)} disabled={!canPreviousPage}><i className="fa fa-angle-double-left"></i></Button>
              <Button className="pagi-btn" onClick={() => previousPage()} disabled={!canPreviousPage}><i className="fa fa-angle-left"></i></Button>
              <Button className="pagi-btn" onClick={() => nextPage()} disabled={!canNextPage}><i className="fa fa-angle-right"></i></Button>
              <Button className="pagi-btn" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><i className="fa fa-angle-double-right"></i></Button>
            </ButtonGroup>
            &nbsp;
            <span>
              Page{' '}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{' '}
            </span>
          </div>
          <div className="col-sm-4"></div>
          <div className="col-sm-3 right-col">
            <Form.Group className="mb-3" >
              <Form.Select as="select" className="textbox-back" value={pageSize}
                onChange={e => {
                  setPageSize(Number(e.target.value))
                }}>
                {[5, 10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize} Rows
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </div>

      </>
    )

  }

  // for custome tooltip of graph
  function CustomTooltip({ payload, label, active }) {
    if (active) {
      return (
        <div className="border bg-white p-2">
          <p>{label}</p>
          <p>No. of alerts for</p>
          <p style={{ color: "#3368F2" }}>Engine High Coolant Temp. : {payload[0].payload["Engine High Coolant Temp."]}</p>
          <p style={{ color: "#FA2C50" }}>High Transmission Oil Temp. : {payload[0].payload["High Transmission Oil Temp."]}</p>
          <p style={{ color: "#FF9800" }}>Battery Charging : {payload[0].payload["Battery Charging"]}</p>
          <p style={{ color: "#795548" }}>Clogged Air Cleaner : {payload[0].payload["Clogged Air Cleaner"]}</p>
          <p style={{ color: "#673AB7" }}>OPS : {payload[0].payload["OPS"]}</p>
          <p style={{ color: "#8BC34A" }}>Low Fuel Level Warning : {payload[0].payload["Low Fuel Level Warning"]}</p>
          <p style={{ color: "#B7117F" }}>Engine Oil Pressure : {payload[0].payload["Engine Oil Pressure"]}</p>
        </div>
      );
    }

    return null;
  }
  // for custome tooltip of graph
  function dateConvert(dt) {
    let yy = dt.slice(0, 4);
    let mm = parseInt(dt.slice(-2));
    return yy + " " + monthName[mm - 1];
}

  return (
    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <h4 className='main-heading'>Incident</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Incident</p>
      {
        dashboard.indexOf(801) == -1 ? "" :
          <div className="row mt-3">
            <div className="col-sm-12 full-col">
              <div className="card-box-block">
                <div className="row">
                  <div className="col-sm-10">
                    <h6 className='cardtitle'>Incident Count : {dateConvert(filterHis['801'].month)}</h6>
                  </div>
                  <div className="col-sm-2  text-end">
                    <FontAwesomeIcon icon={faBars} onClick={() => handleShow(801)} />
                  </div>
                </div>
                <hr />
                <div className='row horizontal-scroll' ref={parentRef}>
                  {
                    incident.length ?
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart
                          data={incident}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                          }}
                        >
                          <CartesianGrid vertical={false} strokeDasharray="3 3" />
                          <XAxis dataKey="day" />
                          <YAxis />
                          <Tooltip content={<CustomTooltip />} />
                          <Legend />
                          <Line type="monotone" dataKey="Engine High Coolant Temp." stroke="#3368F2" strokeWidth={2} activeDot={{ r: 4 }} />
                          <Line type="monotone" dataKey="High Transmission Oil Temp." stroke="#FA2C50" strokeWidth={2} activeDot={{ r: 4 }} />
                          <Line type="monotone" dataKey="Battery Charging" stroke="#FF9800" strokeWidth={2} activeDot={{ r: 4 }} />
                          <Line type="monotone" dataKey="Clogged Air Cleaner" stroke="#795548" strokeWidth={2} activeDot={{ r: 4 }} />
                          <Line type="monotone" dataKey="OPS" stroke="#673AB7" strokeWidth={2} activeDot={{ r: 4 }} />
                          <Line type="monotone" dataKey="Low Fuel Level Warning" stroke="#8BC34A" strokeWidth={2} activeDot={{ r: 4 }} />
                          <Line type="monotone" dataKey="Engine Oil Pressure" stroke="#B7117F" strokeWidth={2} activeDot={{ r: 4 }} />
                        </LineChart>
                      </ResponsiveContainer>
                      :
                      <p className='text-center'><b>No Data Available</b></p>
                  }
                </div>
              </div>
            </div>
          </div>
      }
      {
        dashboard.indexOf(802) == -1 ? "" :
          <div className="row mt-3 card-box-block">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-10">
                  <h6 className='cardtitle'>Hours Operated - Last Incident</h6>
                </div>
                <div className="col-sm-2  text-end">
                  <FontAwesomeIcon icon={faBars} onClick={() => handleShow(802)} />
                </div>
              </div>
              <hr />
              {
                lastIncident.length ?
                  <Table columns={columns} data={lastIncident} />
                  :
                  <p className='text-center'><b>No Data Available</b></p>
              }
            </div>
          </div>
      }
      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>Filter</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className='row'>
            {
              filterDash == 801 ?
                <>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>Month</Form.Label>
                      <Form.Control type='month' placeholder='Month' name='month' value={filter.month} max={yyyy+"-"+mm}
                        className="textbox-back" onChange={getFilterData} />
                    </Form.Group>
                  </div>
                </>
                : ""
            }
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Category</label>
                <Form.Select as='select' name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Sub Category</label>
                <Form.Select as='select' name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Site</label>
                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                  <option value="">Select Site</option>
                  {
                    siteList.map((item, index) =>
                      <option key={index} value={item.siteID}>{item.siteName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <label>Equipment ID</label>
                <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                  <option value="">Select Equipment ID</option>
                  {
                    allAseet.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Equipment Type</label>
                <Form.Select as='select' name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                  <option value="">Select Equipment Type</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <button className="btn btn-outline-secondary lo-btn" onClick={() => clearFilter(filterDash)}>
              Reset
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
              Apply
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
              Apply All
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Incident
